import { useEffect, useState } from "react"

import ErrorPage from "@/components/error-page"
import { Fonts } from "./fonts"

export function UnhandledErrorComponent(_: { error: unknown; info: unknown }) {
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    // Track if ErrorPage itself fails
    const handleError = () => setHasError(true)
    window.addEventListener("error", handleError)
    return () => window.removeEventListener("error", handleError)
  }, [])

  // If ErrorPage fails, show a simple fallback
  if (hasError) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-black p-8 text-white">
        <div className="text-center">
          <h1 className="mb-4 font-circular text-3xl">Something went wrong</h1>
          <p className="mb-4">Please refresh the page or try again later.</p>
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
          <a href="/" className="rounded-sm bg-white px-4 py-2 text-black">
            Go Home
          </a>
        </div>
      </div>
    )
  }

  return (
    <>
      <Fonts />
      <ErrorPage />
    </>
  )
}
